import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map, shareReplay, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'eic-recently-added-assets-container',
  template: `<div class="recently-added-assets-container">To be populated later</div>`
})
export class RecentlyAddedAssetsContainerComponent implements OnInit, OnDestroy {
  assets$: Observable<any[]> = of([]);
  private readonly destroy$ = new Subject<void>();

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.assets$ = this.loadRecentlyAddedAssets();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadRecentlyAddedAssets(): Observable<any[]> {
    return this.http.get<any[]>('/api/assets/recentlyAdded').pipe(
      takeUntil(this.destroy$),
      map((items) => Array.isArray(items) ? items : []),
      catchError(() => of([])),
      shareReplay(1)
    );
  }
}
